module.exports = __webpack_public_path__ + "img/24b)(Reichstag) Einrichtung Plenarsaal.jpg";